import { render, staticRenderFns } from "./EmailNotificationUtentiView.vue?vue&type=template&id=ae277a44"
import script from "./EmailNotificationUtentiView.vue?vue&type=script&lang=js"
export * from "./EmailNotificationUtentiView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports